import qs from "qs";

export class ServiceClient {
  constructor(httpClient, baseURL) {
    this.httpClient = httpClient;
    this.baseURL = `${baseURL}/services`;
  }

  async search(params) {
    const queryString = qs.stringify(params, {
      addQueryPrefix: true
    });
    const url = `${this.baseURL}/search${queryString}`;
    const response = await this.httpClient.request("get", url);

    return response;
  }

  async searchWithUnavailableDate(params) {
    const queryString = qs.stringify(params, {
      addQueryPrefix: true
    });

    const url = `${this.baseURL}/unavailable${queryString}`;
    const response = await this.httpClient.request("get", url);

    return response;
  }

  async list() {
    const url = this.baseURL;

    const response = await this.httpClient.request("get", url);

    return response;
  }

  async get(id) {
    const url = `${this.baseURL}/${id}`;

    const response = await this.httpClient.request("get", url);

    return response;
  }

  async getWorkdays(id) {
    const url = `${this.baseURL}/${id}/workdays`;

    const response = await this.httpClient.request("get", url);

    return response;
  }

  async putWorkdays(id, data) {
    const url = `${this.baseURL}/${id}/workdays`;

    const response = await this.httpClient.request("put", url, {
      data
    });

    return response;
  }

  async postServiceWorkdays(params) {
    const url = `${this.baseURL}/workdays`;

    const response = await this.httpClient.request("post", url, {
      data: params
    });

    return response;
  }

  async post(params) {
    const url = this.baseURL;

    const response = await this.httpClient.request("post", url, {
      data: params
    });

    return response;
  }

  async put(id, params) {
    const url = `${this.baseURL}/${id}`;

    const response = await this.httpClient.request("put", url, {
      data: params
    });

    return response;
  }

  async delete(id) {
    const url = `${this.baseURL}/${id}`;

    const response = await this.httpClient.request("delete", url);

    return response;
  }

  async getLocalization(id, language) {
    const url = `${this.baseURL}/${id}`;

    const response = await this.httpClient.request("get", url, {
      headers: { "x-accept-language": language }
    });

    return response;
  }

  async putLocalization(id, params, language) {
    const url = `${this.baseURL}/${id}/translation`;

    const response = await this.httpClient.request("put", url, {
      data: params,
      headers: { "x-accept-language": language }
    });

    return response;
  }
}
